<template>
  <v-container fluid class="px-0">
    <v-row>
      <v-col
        style="max-width: 15rem !important"
        v-for="(table, index) in tables"
        :key="index"
        cols="12"
        md="3"
      >
        <sub-menu-card
          :title="table.title"
          :isSelected="table.name === $route.name"
          :itemKey="table.key"
          @click="subMenuClicked(table.name)"
        />
      </v-col>
    </v-row>
    <services v-if="$route.name === 'classifierServicesList'" />
    <service-extra-fields v-else-if="$route.name === 'classifierServiceExtraFields'" />
  </v-container>
</template>

<script>
import SubMenuCard from '@/components/cards/SubMenuCard'
import Services from './Services.vue'
import ServiceExtraFields from './ServiceExtraFields.vue'

export default {
  name: 'ServicesIndex',
  components: {
    SubMenuCard,
    Services,
    ServiceExtraFields,
  },
  computed: {
    tables() {
      return [
        {
          key: 'servicesList',
          title: this.$t('Paslaugos ir veiksmai'),
          name: 'classifierServicesList',
        },
        {
          key: 'serviceExtraFields',
          title: this.$t('Papildomi paslaugų laukai'),
          name: 'classifierServiceExtraFields',
        },
      ]
    },
  },
  methods: {
    subMenuClicked(route) {
      this.$router.push({ name: route })
    },
  },
}
</script>
